import type { DocMigration } from "../docMigration";

const acronyms = ["URL", "QR", "ID", "PDF", "DXF", "JPG", "PNG", "JPEG", "SVG", "DWG", "FBX"];

function isAcronym(str: string) {
  return str.length < 5 && acronyms.includes(str.toUpperCase());
}

function snakeCaseToTitleOrSentenceCase(str: string | null | undefined, titleCase: boolean, preserveAcronyms: boolean) {
  if (!str) {
    return "";
  }
  // This also has to support strings that are already in title case, so we can't just split by underscores,
  // we also have to use a regex that preserves whitespace already present in the string and separates the words.
  let wordIndex = 0;
  return str.replace(/_/g, " ").replace(/\w\S*/g, (word) => {
    ++wordIndex;
    if (preserveAcronyms && isAcronym(word)) {
      return word.toUpperCase();
    }
    if (titleCase || wordIndex === 1) {
      return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
    }
    return word.toLowerCase();
  });
}

export function snakeCaseToSentenceCase(str: string, preserveAcronyms = true) {
  return snakeCaseToTitleOrSentenceCase(str, false, preserveAcronyms);
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_510: DocMigration = {
  maxSchemaVersion: "0.0.510",
  description: "Add valid name property to annotations with missing names",
  apply(json: any): any {
    const { annotation = {} } = json;

    for (const id in annotation) {
      const entity = annotation[id];
      if (!("name" in entity)) {
        entity.name = entity.type ? snakeCaseToSentenceCase(entity.type) : "Annotation";
      }
    }

    return json;
  },
};

export default migration_0_0_510;
